import PropTypes from 'prop-types';
import { memo } from 'react';

import {
  ArticleWrapperStyled,
  ArticleContentStyled,
  ArticleHeaderStyled,
  ExcerptStyled,
  ArticleImageWrapperStyled,
  ArticleImageStyled,
  FindMoreStyled
} from './styled/ArticleItem';

const ArticleItem = ({
  item: {
    thumbnail, title, url, articleExcerpt, altText
  }
}) => (
  <ArticleWrapperStyled>
    <div>
      <ArticleContentStyled href={url}>
        <ArticleHeaderStyled>{title}</ArticleHeaderStyled>
        <ExcerptStyled>{articleExcerpt}</ExcerptStyled>
      </ArticleContentStyled>
      <FindMoreStyled kind="sm" link={url}>Find out more</FindMoreStyled>
    </div>
    <ArticleImageWrapperStyled href={url}>
      <ArticleImageStyled
        src={thumbnail}
        alt={altText}
        loading="lazy"
      />
    </ArticleImageWrapperStyled>
  </ArticleWrapperStyled>
);

const propTypes = {
  item: PropTypes.shape({
    articleExcerpt: PropTypes.string,
    altText: PropTypes.string,
    title: PropTypes.string,
    thumbnail: PropTypes.string,
    url: PropTypes.string
  }).isRequired
};

ArticleItem.propTypes = propTypes;

export default memo(ArticleItem);
